export enum FrontendType {
    ADMIN = 'admin',
    CUSTOMER = 'customer'
}
